import { AuthService } from '@core/services/auth.service';
import { QuestionService } from '../../../data/question.service';

import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '@shared/components/button/button.component';
import { StepperComponent } from '../../stepper/stepper.component';
import { TranslationDirective } from '@shared/components/translata-modal/translation.directive';
import { QuestionTemplate } from '../question-template';
import { SeparatorComponent } from '@shared/components/separator/separator.component';

@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss'],
  imports: [TranslationDirective, TranslateModule, ButtonComponent, StepperComponent, SeparatorComponent],
})
export class OverviewComponent extends QuestionTemplate {
  welcomeName: string;
  headerImagePath: string;
  logoImagePath: string;
  quests = inject(QuestionService);

  stepsCount = this.quests.steps().length;
  constructor(auth: AuthService, questionService: QuestionService, route: ActivatedRoute) {
    const url = route.snapshot.url;
    let path = '';
    if (url.length > 0) path = url[0].path;
    super(auth, questionService, path);
    this.questionName = 'overview';
    let index = this.auth.findFlaggedNaturalPerson(this.auth.user.natPersonen);
    let title = this.auth.user.natPersonen[index].Person.Titel;
    let vorname = this.auth.user.natPersonen[index].Person.Vorname;
    let nachname = this.auth.user.natPersonen[index].Person.Nachname;
    let anrede = this.auth.user.natPersonen[index].Person.Anrede;

    this.welcomeName = 'Hallo ' + anrede + ' ' + title + ' ' + vorname + ' ' + nachname;

    window.localStorage.clear();
  }
}
